import { render, staticRenderFns } from "./propertyCarRecordList.vue?vue&type=template&id=4feceda1&"
import script from "./propertyCarRecordList.vue?vue&type=script&lang=js&"
export * from "./propertyCarRecordList.vue?vue&type=script&lang=js&"
import style0 from "./propertyCarRecordList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports